import { farasodAuth } from "./api"

const endpoint = "/access"

export const getAccess = async (accessId) => {
  const response = await farasodAuth.get(`${endpoint}/${accessId}`)

  return response.data
}

export const getAccesses = async () => {
  const response = await farasodAuth.get(`${endpoint}`)

  return response.data
}

export const createAccess = async (data) => {
  const response = await farasodAuth.post(`${endpoint}`, data)

  return response.data
}

export const editAccess = async (accessId, data) => {
  const response = await farasodAuth.patch(`${endpoint}/${accessId}`, data)

  return response.data
}

export const deleteAccess = async (accessId) => {
  const response = await farasodAuth.delete(`${endpoint}/${accessId}`)

  return response.data
}